import R from 'ramda';
import {
  NEWSLETTER_REQUEST_START,
  NEWSLETTER_REQUEST_PENDING,
  NEWSLETTER_REQUEST_FAIL,
  NEWSLETTER_REQUEST_SUCCESS,
  RESET_NEWSLETTER,
  NEWSLETTER_SET_INPUT_VALUE,
  NEWSLETTER_RESET_INPUT_VALUE,
} from './types';

const initialState = {
  value: '',
};

const requestPending = (state, { pending }) => ({
  ...state,
  pending,
});

const requestSuccess = state => ({
  ...state,
  success: true,
  error: false,
});

const requestFail = (state, { status }) => ({
  ...state,
  status,
  error: true,
  success: false,
});

const requestStart = (state, { email }) => ({
  ...state,
  email,
});

const resetNewsletter = R.omit(['pending', 'status', 'error', 'success', 'email']);

const setInputValue = (state, { value }) => ({
  ...state,
  value,
});

const resetInputValue = state => ({
  ...state,
  value: '',
});

const reducer = {
  [NEWSLETTER_REQUEST_PENDING]: requestPending,
  [NEWSLETTER_REQUEST_SUCCESS]: requestSuccess,
  [NEWSLETTER_REQUEST_FAIL]: requestFail,
  [NEWSLETTER_REQUEST_START]: requestStart,
  [RESET_NEWSLETTER]: resetNewsletter,
  [NEWSLETTER_SET_INPUT_VALUE]: setInputValue,
  [NEWSLETTER_RESET_INPUT_VALUE]: resetInputValue,
};

export default (state = initialState, action) => (
  action.type && reducer[action.type] ? reducer[action.type](state, action) : state
);
